<template>
	<a :href="href" target="_blank" rel="noopener noreferrer" class="link-pill">
		<slot />
		<AppIcon :name="IconName.ArrowUpRight" :size="12" :stroke-width="2" />
	</a>
</template>

<script setup lang="ts">
import AppIcon from "@/components/AppIcon.vue"
import { IconName } from "@/components/icons/registry"

defineProps<{ href: string }>()
</script>

<style scoped>
.link-pill {
	display: inline-flex;
	align-items: center;
	gap: var(--spacing-xxs);
	padding: var(--spacing-xxs) var(--spacing-sm);
	border-radius: var(--border-radius-full);
	background-color: var(--neutral-100);
	color: var(--neutral-700);
	font-size: var(--font-size-xs);
	font-weight: var(--font-weight-medium);
	text-decoration: none;
	transition:
		background-color 0.2s ease,
		color 0.2s ease;

	&:hover {
		background-color: var(--neutral-200);
		color: var(--neutral-900);
	}
}
</style>
